export default Vue => {
	// Define contexts to require
	const contexts = [
		require.context( '@/components/', true, /\.vue$/ ),
	];

	// Define components
	const components = [];

	contexts.forEach( context => {
		context.keys().forEach( key => components.push( context( key ).default ) );
	} );

	// Install the above defined components
	components.forEach( component => Vue.component( component.name, component ) );
};
